import Text from '@components/Text';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

function SoldOut() {
    const { t } = useTranslation('cart');
    return (
        <Wrapper>
            <Container>
                <Background/>
                <Text size='s' fontWeight='bold' css={textCss}>
                    {t('item.soldOut')}
                </Text>
            </Container>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Container = styled.div`
    align-items: center;
    display: flex;
    height: 24px;
    justify-content: center;
    position: relative;
    transform: rotate(-18deg);
    width: 88px;
`;

const Background = styled.div`
    background-color: var(--color-primary);
    height: 100%;
    opacity: .66;
    position: absolute;
    width: 100%;
`;

const textCss = css`
    font-size: 11px !important;
    line-height: 11px !important;
    position: relative;
    color: var(--color-button-text);
`;

export default SoldOut;
